import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { Input } from 'oio-react'

const ConnectedInput = ({ name, ...inputProps }) => (
   <Field
      name={name}
      render={({ field }) => (
         <Input name={name} {...field} {...inputProps} />
      )}
   />
)

ConnectedInput.propTypes = {
   name: PropTypes.string.isRequired
}

export default ConnectedInput
